import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { getCurrentLocalTime } from "common/date-utils";
import React from "react";
import { useDispatch } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { closeDialog } from "store/messages-dialog";
import { useBulkDeleteNotesMutation } from "store/notes/api";
import { useGetSelectedNoteId } from "components/pages/notes/hooks";
export const InsDeleteNoteDialogAction = () => {
    const dispatch = useDispatch();
    const [bulkDeleteNotes, { isLoading: isDeleting }] = useBulkDeleteNotesMutation();
    const noteId = useGetSelectedNoteId();
    const handleDelete = async () => {
        if (!noteId) {
            return;
        }
        await bulkDeleteNotes({
            ids: [noteId]
        }).unwrap();
        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.NotesDeleteNote, properties: { LocalTimestamp: getCurrentLocalTime() } }, { noteId: String(noteId) });
        dispatch(closeDialog());
    };
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.delete, key: "delete-note-button", type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, isDisabled: !noteId || isDeleting, onClick: handleDelete }),
        React.createElement(CloseDialogButton, null));
};
